import { styled, useTheme } from '@auth0/quantum-product';

const OptInBannerBar = styled('div')(({ theme }) => ({
  position: 'fixed', // Make banner fixed at top
  top: 10,
  left: 0,
  width: '100%',
  zIndex: 2001, // Higher than header
  background: theme.palette.mode === 'dark' ? theme.tokens.color_bg_dark : theme.tokens.color_bg_light,
  color: theme.palette.mode === 'dark' ? '#fff' : '#222',
  fontSize: 'clamp(0.75rem, 1.5vw, 0.95rem)',
  fontFamily: 'Aeonik, Inter, sans-serif',
  padding: theme.spacing(0, 1, 1.5, 1),
  margin: 1,
  height: '30px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const OptInBanner = () => {
  const theme = useTheme();

  const handleOptIn = async (e) => {
    e.preventDefault();
    try {
      await fetch('/docs/v2/rollout/consent', {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ choice: 'opt_in' }),
      });
      window.location.reload();
    } catch (err) {
      console.error('Opt-in failed', err);
    }
  };

  return (
    <OptInBannerBar>
      ✨ Try the new Auth0 Docs - faster navigation and a better developer experience.
      <a
        href="#"
        onClick={handleOptIn}
        style={{
          color: theme.palette.mode === 'dark' ? '#fff' : '#222',
          background: theme.palette.mode === 'dark' ? theme.tokens.color_bg_dark : theme.tokens.color_bg_light,
          textDecoration: 'underline',
          marginLeft: '1em',
          cursor: 'pointer',
          fontWeight: 400,
        }}
      >
        Switch to a new version.
      </a>
    </OptInBannerBar>
  );
};

export default OptInBanner;
